
import { MenuItem, Select, FormControl, InputLabel } from '@mui/material';
import { styled } from '@mui/system';

const FONT_SANS = 'Inter, Nunito, system-ui, sans-serif';

const StyledSelect = styled(Select, {
  shouldForwardProp: (prop) => prop !== 'fullWidth',
})(({ theme, fullWidth }) => ({
  height: '32px',
  borderRadius: '16px',
  minWidth: fullWidth ? '0' : '200px',
  width: fullWidth ? '100%' : 'auto',
  padding: '0 12px',
  backgroundColor: theme.palette.background.default,
  fontSize: '0.875rem',
  fontFamily: FONT_SANS,
  '& .MuiSelect-select': {
    display: 'flex',
    alignItems: 'center',
    paddingLeft: '12px',
    paddingRight: '32px', // espacio para el icono de flecha
  },
  '& .MuiOutlinedInput-notchedOutline': {
    borderColor: theme.palette.grey[400],
  },
  '&:hover .MuiOutlinedInput-notchedOutline': {
    borderColor: theme.palette.grey[500],
  },
  '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
    borderColor: theme.palette.primary.main,
  },
}));

/**
 * FilterControl wraps a styled MUI Select with label and forwarding of MenuProps.
 *
 * Props:
 * - label: string label for the select
 * - value: controlled value
 * - onChange: callback invoked with new value
 * - options: array [{ label, value }]
 * - disabled: boolean
 * - MenuProps: optional MUI MenuProps to configure popup behavior
 */
const FilterControl = ({
  label,
  value,
  onChange,
  options = [],
  disabled = false,
  MenuProps: customMenuProps = null,
  fullWidth = false,
}) => {
  // Default MenuProps
  const defaultMenuProps = {
    PaperProps: {
      sx: {
        '& .MuiMenuItem-root': { fontSize: '0.7rem' },
        maxHeight: 200,
      },
    },
    anchorOrigin: { vertical: 'bottom', horizontal: 'left' },
    transformOrigin: { vertical: 'top', horizontal: 'left' },
  };

  return (
    <FormControl
      variant="outlined"
      style={{
        marginBottom: 0,
        alignItems: 'stretch',
        minWidth: fullWidth ? '0' : '150px',
        width: fullWidth ? '100%' : undefined,
      }}
    >
      <InputLabel
        shrink
        sx={{
          fontFamily: FONT_SANS,
          fontSize: '0.75rem',
          fontWeight: 500,
          color: 'gray',
          backgroundColor: 'transparent',
          transform: 'translate(12px, -15px)',
          padding: '0 4px',
        }}
      >
        {label}
      </InputLabel>
      <StyledSelect
        value={value}
        onChange={e => onChange(e.target.value)}
        displayEmpty
        variant="outlined"
        color="primary"
        disabled={disabled}
        autoWidth
        MenuProps={customMenuProps || defaultMenuProps}
        fullWidth={fullWidth}
      >
        {options.map(opt => (
          <MenuItem
            key={opt.value}
            value={opt.value}
            className="font-sans"
          >
            {opt.label}
          </MenuItem>
        ))}
      </StyledSelect>
    </FormControl>
  );
};

export default FilterControl;
